import React, { Component } from "react";
import Header from "../../Layout/Header/Header";
import Footer from "../../Layout/Footer/Footer";
import imgBg from "../../../Assets/img/Group 2521.svg";
import imgMain from "../../../Assets/img/forgot_password.svg";
import verification_pending from "../../../Assets/img/verification_pending.svg";
import { authenticate, make_request } from "../../Utils/Utils";
import ReCAPTCHA from "react-google-recaptcha";

const forgot_pwd_recaptcha_ref = React.createRef();

class ForgotPassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      request_created: false,
      email: '',
      validation_alert: false
    };
  }

  componentDidMount(){
    if(authenticate()) {
      this.props.history.push('/pre-start');
    }
  }

  handle_change = (event) => {
    this.setState({[event.target.name]: event.target.value});
  }

  resetCaptcha = () => {
    forgot_pwd_recaptcha_ref.current.reset();  
  }

  submit_request = async () => {
    const recaptcha_response = await forgot_pwd_recaptcha_ref.current.executeAsync();
    if(!!recaptcha_response) {
      this.setState({validation_alert: false, submitted: true});
      let responseJson = await make_request({
        path: 'auth/password',
        method: 'POST',
        body: {
          email: this.state.email,
          redirect_url: process.env.REACT_APP_DOMAIN+"/reset-password",
          recaptcha_response: recaptcha_response
        }
      });
      if (responseJson) {
        this.setState({request_created: true, validation_alert: false});
      } else {
        this.setState({submitted: false, validation_alert: true});
      }
    }
  }

  render() {
    return (
      <div className="ForgotPassword innerBody">
        <Header />
        <div className="container">
          <div className="row">
            <div className="col text-center sub_head">
            <img src={imgBg} alt="" className="bg-img pt-5"/>
            {
              this.state.request_created ? (
                <h5>
                  Reset password instructions have been sent to your email.
                </h5>
              ) : (
                <div>
                  <h3 className="title ml-auto mr-auto text-center mt-3 pt-2">
                    FORGOT PASSWORD ?
                  </h3>
                  <h5> Enter the email ID registered with Puzzled</h5>
                  <div className="col-lg-4 col-md-12 col-12 offset-lg-4">
                    <div className="row mt-5">
                      <div className="col-lg-9 col-md-12 col-12 pt-3">
                        <input name="email" type="email" id="input-email" className="form-control" placeholder="Email Address *" value={this.state.email} onChange={this.handle_change} />
                      </div>
                      <div className="col-lg-3 col-md-12 col-12 pt-3 text-center">
                        <ReCAPTCHA
                          ref={forgot_pwd_recaptcha_ref}
                          size="invisible"
                          sitekey={process.env.REACT_APP_GOOGLE_SITE_KEY}
                          onChange={this.resetCaptcha}
                        />
                        <button disabled={this.state.submitted} onClick={this.submit_request} className="btn btn-yellow g-recaptcha">
                          SUBMIT
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="wrong_txt mt-4 text-center">
                    {
                      this.state.validation_alert &&
                      <p> Enter correct Email ID </p>
                    }
                  </div>

                </div>
              )
            }
            </div>
          </div>

            {
              this.state.request_created ? (
                <div className="row">
            <div className="col text-center mt-3 mb-4">
              <img src={verification_pending} className="verification_img" alt="" />
              <img src={imgBg} alt="" className="bg-img img-main pt-1" />
            </div>
          </div>
              ) : (
          <div className="row">
            <div className="col text-center mt-3 mb-4">
              <img src={imgMain} alt="" />
              <img src={imgBg} alt="" className="bg-img img-main pt-1" />
            </div>
          </div>
          )

          }

        </div>
        <Footer />
      </div>
    );
  }
}

export default ForgotPassword;
